import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="content-footer">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal-materials-wrapper-content-footer {
                display: contents;
            }

            .content-footer {
                display: flex;
                gap:  calc(var(--gap) * 10);
                background: var(--background-gray-2);
                justify-content: end;
                width: 100%;
                max-width: calc(var(--max-content-width) + var(--spacing) * 2);
                margin: var(--spacing) auto;
                box-sizing: border-box;
                padding: 0 var(--spacing);
            }

            @media (min-width: 1013px) {
                .content-footer {
                    padding: 0;
                }
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/content/footer/index.js